import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FaRegStar } from 'react-icons/fa';
import { IoIosArrowForward } from 'react-icons/io';

import { ROUTES } from 'utils/constants';

import './go-plus-card.scss';

const GoPlusCard = () => {
  const { t } = useTranslation();
  const { push } = useHistory();

  return (
    <button type="button" className="go-plus-card" onClick={() => push(`${ROUTES.EVIE_ONBOARDING}?view=plans&entry=go_plus`)}>
      <div className="go-plus-card__staricon">
        <FaRegStar />
      </div>
      <div className="go-plus-card__content">
        <h2>{t('evieApp.goPlusCard.title')}</h2>
        <p>{t('evieApp.goPlusCard.content')}</p>
      </div>
      <IoIosArrowForward size={28} />
    </button>
  );
};

export default GoPlusCard;
